import { Injector }             from '@angular/core';
import { Transition, UIRouter } from '@uirouter/core';
import { SessionService } from '../../app-lite/sessions/session.service';
import { ApiErrorModel } from '../core/api/models/api.error';

import { ErrorHandlingService } from '../core/errors/error-handling.service';

export function RouterConfig (
  router  : UIRouter,
  injector: Injector
) {
  const privateGlob = 'private.**';

  router.transitionService.onEnter({
    to: privateGlob
  }, ( transition : Transition ) => {
    const sessionService : SessionService = injector.get(SessionService);

    if (!sessionService.sessionID()) {
      return transition.router.stateService.target('ajs.app.public.login');
    }
  });

  router.transitionService.onError({
    to: privateGlob
  }, ( transition : Transition ) => {
    const error                : ApiErrorModel        = transition.error().detail;
    const errorHandlingService : ErrorHandlingService = injector.get(ErrorHandlingService);
    const sessionService       : SessionService       = injector.get(SessionService);

    if (errorHandlingService.isSessionExpired(error)) {
      sessionService.clear();

      console.error(error);

      transition.router.stateService.go('ajs.app.public.login');

      return false;
    }
  });
}
